import List from 'list.js';

const sortLists = document.querySelectorAll(".js-sortList");
if (sortLists.length > 0) {
    sortLists.forEach((sortList) => {
        const sortSchema = JSON.parse(sortList.getAttribute("data-sort-schema"));
        const searchSchema = JSON.parse(sortList.getAttribute("data-search-schema"));
        const options = {
            valueNames: sortSchema,
            searchColumns: searchSchema,
        };
        const listObj = new List(sortList, options);
        const searchField = document.querySelector(".js-search-field");
        const resetButton = document.querySelectorAll(".js-reset-button");
        const emptyState = document.querySelector(".js-empty-state");
        let itemsCount = document.querySelector(".js-list-count");
        // Update length count initialy
        itemsCount.innerHTML = listObj.items.length;

        listObj.on('updated', function (list) {
            itemsCount.innerHTML = list.matchingItems.length;
            if (list.matchingItems.length === 0) {
                emptyState.classList.remove("hidden");
            } else {
                emptyState.classList.add("hidden");
            }
        });

        if (searchField.length > 0) {
            searchField.addEventListener("keyup", function () {
                let searchString = document.querySelector(this).value;
                itemsCount.innerHTML = listObj.matchingItems.length;
                listObj.search(searchString);
                listObj.reIndex();
            });
        }
        resetButton.forEach((element) => {
            element.addEventListener("click", (e) => {
                searchField.value = "";
                listObj.search();
                listObj.filter();
                listObj.update();
            });
        });
    });
}
